import Select from "../../../../components/select/Select";
import { SettingsRow } from "../settings-row/SettingsRow";

const HEIGHT_UNITS = ["cm", "ft"];

export const HeightSelector = ({
  unit = "cm",
  onUnitChange,
  disabled = false,
}) => {
  const handleChange = event => {
    const newUnit = event.target.value;
    if (newUnit && newUnit !== unit && onUnitChange) {
      onUnitChange(newUnit);
    }
  };

  return (
    <SettingsRow
      labelKey="287"
      className="settings-height-selector"
      id="height-selector"
    >
      <Select
        items={HEIGHT_UNITS}
        onChange={handleChange}
        selectedItem={unit}
        id="height-selector-select"
        disable={disabled}
      />
    </SettingsRow>
  );
};
